import {createFileRoute} from '@tanstack/react-router';
import {BonusPointShopPage} from 'pages/bonus/BonusPointShopPage';

export const Route = createFileRoute(
  '/_protected/home/accounts/credits/$accountId/bonus-shop/',
)({
  component: BonusPointShopPage,
});
